const autoNgTemplateLoaderTemplate1 = require('./groupsDatatable.html');

import angular from 'angular';

import { EdgeGroupsDatatableController } from './groupsDatatableController';

angular.module('shbdeployer.edge').component('edgeGroupsDatatable', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: EdgeGroupsDatatableController,
  bindings: {
    dataset: '<',
    titleIcon: '@',
    tableKey: '@',
    orderBy: '@',
    removeAction: '<',
    updateAction: '<',
    reverseOrder: '<',
  },
});
